import { RESET_USER } from ".";
import { methods } from "../constants/constants";
import { getMateriaById } from "../utils/dataHandlers/MateriasDataHandler";

export const types = {
  GET_MATERIAS_BEGINS: 'MATERIAS/GET_MATERIAS_BEGINS',
  GET_MATERIAS_SUCCESS: 'MATERIAS/GET_MATERIAS_SUCCESS',
  GET_MATERIAS_FAILURE: 'MATERIAS/GET_MATERIAS_FAILURE',
  GET_MATERIAS_UPDATE: 'MATERIAS/GET_MATERIAS_UPDATE',

  POST_MATERIAS_BEGINS: 'MATERIAS/POST_MATERIAS_BEGINS',
  POST_MATERIAS_SUCCESS: 'MATERIAS/POST_MATERIAS_SUCCESS',
  POST_MATERIAS_FAILURE: 'MATERIAS/POST_MATERIAS_FAILURE',
  RESET_POST_MATERIAS: 'MATERIAS/RESET_POST_MATERIAS',

  EDIT_MATERIAS_BEGINS: 'MATERIAS/EDIT_MATERIAS_BEGINS',
  EDIT_MATERIAS_SUCCESS: 'MATERIAS/EDIT_MATERIAS_SUCCESS',
  EDIT_MATERIAS_FAILURE: 'MATERIAS/EDIT_MATERIAS_FAILURE',
  RESET_EDIT_MATERIAS: 'MATERIAS/RESET_EDIT_MATERIAS',


  DELETE_MATERIAS_BEGINS: 'MATERIAS/DELETE_MATERIAS_BEGINS',
  DELETE_MATERIAS_SUCCESS: 'MATERIAS/DELETE_MATERIAS_SUCCESS',
  DELETE_MATERIAS_FAILURE: 'MATERIAS/DELETE_MATERIAS_FAILURE',
  RESET_DELETE_MATERIAS: 'MATERIAS/RESET_DELETE_MATERIAS',

  GET_MATERIAS_DISPONIBLES_BEGINS: 'MATERIAS/GET_MATERIAS_DISPONIBLES_BEGINS',
  GET_MATERIAS_DISPONIBLES_SUCCESS: 'MATERIAS/GET_MATERIAS_DISPONIBLES_SUCCESS',
  GET_MATERIAS_DISPONIBLES_FAILURE: 'MATERIAS/GET_MATERIAS_DISPONIBLES_FAILURE',

}

export const initialState = {
  
  materias: null,
  materiasFetching: false,
  materiasError: null,
  materiasStatus: null,
  materiasStatusData: null,
  materiasStatusFetching: false,
  materiasStatusError: null,

  materiasEditStatus: null,
  materiasEditStatusData: null,
  materiasEditStatusFetching: false,
  materiasEditStatusError: null,

  materiasDeleteStatus: null,
  materiasDeleteStatusData: null,
  materiasDeleteStatusFetching: false,
  materiasDeleteStatusError: null,

  materiasDisponibles: null,
  materiasDisponiblesFetching: false,
  materiasDisponiblesError: null,

}

const MateriasReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER:
      return initialState;

    case types.GET_MATERIAS_BEGINS: {
      return {
        ...state,
        materiasFetching: true,
        materiasError: null,
      }
    }
    case types.GET_MATERIAS_SUCCESS: {
          //debugger;
      const data = action.payload;
      return {
        ...state,
        materias: data,
        materiasFetching: false,
        materiasError: null,
      }
    }
    case types.GET_MATERIAS_FAILURE:
    return { 
      ...state,
      materiasFetching: false,
      materiasError: action.payload,
    }
    case types.GET_MATERIAS_UPDATE: {
      const { data, method } = action.payload;
      const currentMaterias = Array.isArray(state.materias) ? [...state.materias] : [];
      const exist = getMateriaById(currentMaterias, data.id);
      let updateMaterias = currentMaterias;

      if (method === methods.DELETE) {
        updateMaterias = currentMaterias.filter((materia) => materia.id !== data.id);
      } else {
        if (!exist) {
          updateMaterias = [...currentMaterias, data];
        } else {
          updateMaterias = currentMaterias.map((materia) => (
            materia.id === data.id
              ? {
                  ...materia,
                  ...data,
                }
              : materia
          ));
        }
      }
      return {
        ...state,
          materias: updateMaterias,
          materiasDisponibles: null,
          materiasRefresh: true,
          materiasFetching: false,
        materiasError: null,
      }
    }
    case types.POST_MATERIAS_BEGINS: {
      return {
        ...state,
        materiasStatusFetching: true,
        materiasStatusError: null,
      }
    }
    case types.POST_MATERIAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        materiasStatus: data.status,
        materiasStatusData: data.data,
          materiasStatusFetching: false,
        materiasRefresh: false,
        materiasStatusError: null,
      }
    }
    case types.POST_MATERIAS_FAILURE:
      return { 
        ...state,
        materiasStatusFetching: false,
        materiasStatusError: action.payload,
    }
    case types.RESET_POST_MATERIAS:
    return { 
      ...state,
      materiasStatus: null,
      materiasStatusData: null,
      materiasStatusFetching: false,
      materiasStatusError: null,
    }
    case types.EDIT_MATERIAS_BEGINS: {
      return {
        ...state,
        materiasEditStatusFetching: true,
        materiasEditStatusError: null,
      }
    }
    case types.EDIT_MATERIAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        materiasEditStatus: data.status,
        materiasEditStatusData: data.data,
        materiasEditStatusFetching: false,
        materiasEditStatusError: null,
      }
    }
    case types.EDIT_MATERIAS_FAILURE:
      return { 
        ...state,
        materiasEditStatusFetching: false,
        materiasEditStatusError: action.payload,
    }
    case types.RESET_EDIT_MATERIAS:
      return { 
        ...state,
        materiasEditStatus: null,
        materiasEditStatusData: null,
        materiasEditStatusFetching: false,
        materiasEditStatusError: null,
    }
    case types.DELETE_MATERIAS_BEGINS: {
      return {
        ...state,
        materiasDeleteStatusFetching: true,
        materiasDeleteStatusError: null,
      }
    }
    case types.DELETE_MATERIAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        materiasDeleteStatus: data.status,
        materiasDeleteStatusData: data.data,
        materiasDeleteStatusFetching: false,
        materiasDeleteStatusError: null,
      }
    }
    case types.DELETE_MATERIAS_FAILURE:
      return { 
        ...state,
        materiasDeleteStatusFetching: false,
        materiasDeleteStatusError: action.payload,
    }
    case types.RESET_DELETE_MATERIAS:
      return { 
        ...state,
        materiasDeleteStatus: null,
        materiasDeleteStatusData: null,
        materiasDeleteStatusFetching: false,
        materiasDeleteStatusError: null,
    }
    case types.GET_MATERIAS_DISPONIBLES_BEGINS: {
      return {
        ...state,
        materiasDisponiblesFetching: true,
        materiasDisponiblesError: null,
      }
    }
    case types.GET_MATERIAS_DISPONIBLES_SUCCESS: {
          //debugger;
      const data = action.payload;
      return {
        ...state,
        materiasDisponibles: data,
        materiasDisponiblesFetching: false,
        materiasDisponiblesError: null,
      }
    }
    case types.GET_MATERIAS_DISPONIBLES_FAILURE:
    return { 
      ...state,
      materiasDisponiblesFetching: false,
      materiasDisponiblesError: action.payload,
    }
  default:
    return state
  }
}

export const actions = {
  getMaterias: () => ({ type: types.GET_MATERIAS_BEGINS }),
  successGetMaterias: data => ({ type: types.GET_MATERIAS_SUCCESS, payload: data, }),
  errorGetMaterias: error => ({ type: types.GET_MATERIAS_FAILURE, payload: error, }),
  updateMaterias: (data, method) => ({ type: types.GET_MATERIAS_UPDATE, payload: { data, method }, }),

  postMaterias: materia => ({ type: types.POST_MATERIAS_BEGINS, materia }),
  successPostMaterias: data => ({ type: types.POST_MATERIAS_SUCCESS, payload: data, }),
  errorPostMaterias: error => ({ type: types.POST_MATERIAS_FAILURE, payload: error, }),
  resetPostMaterias: () => ({ type: types.RESET_POST_MATERIAS }),

  editMaterias: materia => ({ type: types.EDIT_MATERIAS_BEGINS, materia }),
  successEditMaterias: data => ({ type: types.EDIT_MATERIAS_SUCCESS, payload: data, }),
  errorEditMaterias: error => ({ type: types.EDIT_MATERIAS_FAILURE, payload: error, }),
  resetEditMaterias: () => ({ type: types.RESET_EDIT_MATERIAS }),

  deleteMaterias: materia => ({ type: types.DELETE_MATERIAS_BEGINS, materia }),
  successDeleteMaterias: data => ({ type: types.DELETE_MATERIAS_SUCCESS, payload: data, }),
  errorDeleteMaterias: error => ({ type: types.DELETE_MATERIAS_FAILURE, payload: error, }),
  resetDeleteMaterias: () => ({ type: types.RESET_DELETE_MATERIAS }),

  getMateriasDisponibles: () => ({ type: types.GET_MATERIAS_DISPONIBLES_BEGINS }),
  successGetMateriasDisponibles: data => ({ type: types.GET_MATERIAS_DISPONIBLES_SUCCESS, payload: data, }),
  errorGetMateriasDisponibles: error => ({ type: types.GET_MATERIAS_DISPONIBLES_FAILURE, payload: error, }),
}

export default MateriasReducer;